import actionCreator from 'helpers/actionCreator'
import { SETUP_EXPORT, FLOOR_PLAN_READY, MAP_READY,
  CAMERA_MODEL_IMAGE_READY, UPDATE_EXPORT_TYPE, SCREENSHOT_CAPTURED,
  ADD_EXPORT_PROGRESS, UPDATE_EXPORT_PROGRESS, START_EXPORT_ACTION,
  EXPORT_FEEDBACK, DESTROY_EXPORT_PROGRESS, FOV_PREVIEW_READY, CLEAR_FOV_PREVIEW_READY,
  SET_NETWORK_CLOSET_LIST_BOUNDS, NETWORK_CLOSET_LIST_READY, SET_NETWORK_CLOSET_LIST_PAGES } from 'actions/exportActionTypes'

export const setupExportAction = actionCreator(SETUP_EXPORT, 'project', 'cameraDataFilename', 'stepThrough')
export const floorPlanLoadedAction = actionCreator(FLOOR_PLAN_READY)
export const mapReadyAction = actionCreator(MAP_READY)
export const cameraModelImageReadyAction = actionCreator(CAMERA_MODEL_IMAGE_READY)
export const updateExportTypeAndResizeMapAction = actionCreator(UPDATE_EXPORT_TYPE, 'exportType')
export const screenshotCapturedAction = actionCreator(SCREENSHOT_CAPTURED)
export const addExportProgressAction = actionCreator(ADD_EXPORT_PROGRESS, 'info')
export const updateExportProgressAction = actionCreator(UPDATE_EXPORT_PROGRESS, 'info')
export const startExportAction = actionCreator(START_EXPORT_ACTION, 'format')
export const exportFeedbackAction = actionCreator(EXPORT_FEEDBACK, 'dataType', 'data', 'channel')
export const destroyExportProgressAction = actionCreator(DESTROY_EXPORT_PROGRESS, 'id')
export const fovPreviewReadyAction = actionCreator(FOV_PREVIEW_READY)
export const clearFovPreviewReadyAction = actionCreator(CLEAR_FOV_PREVIEW_READY)

/** Called as an action when the network closet list loads */
export const networkClosetListReadyAction = actionCreator(NETWORK_CLOSET_LIST_READY)

/** Called as an action when the network closet list pages are computed */
export const setNetworkClosetListPagesAction = actionCreator(SET_NETWORK_CLOSET_LIST_PAGES, 'pages')



// WEBPACK FOOTER //
// ./src/actions/exportActions.js